export default __webpack_public_path__ + "static/media/skripp.e2415868.png";